import { render, staticRenderFns } from "./AutoAssignmentOptions.vue?vue&type=template&id=75739e4e&scoped=true&"
import script from "./AutoAssignmentOptions.vue?vue&type=script&lang=ts&"
export * from "./AutoAssignmentOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75739e4e",
  null
  
)

export default component.exports